import { Box } from '@mui/material';
import React from 'react';
import SubmittedPortfolio from '../../components/submittedPortfolio/SubmittedPortfolio';

const SubmittedPortfolioPage: React.FC = () => {
    return <Box display={"flex"} width={"100%"} justifyContent={"center"} overflow={"auto"}>
        <Box display={"flex"} flexDirection={"column"} maxWidth={"1386px"} margin={"50px 56px"}>
            <SubmittedPortfolio />
        </Box>
    </Box>
}

export default SubmittedPortfolioPage;